import "./css/overview.css";
import { NavLink } from "react-router-dom";

import "../components/Tabs.css";

import map from "./img/overview/map.png";

import SubHeader from "../components/subHeader";
import dompurify from "dompurify";
import { useTranslation } from "react-i18next";
import i18next from "../config/lang/i18next";
import React, { useRef, useEffect } from "react";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const Overview = () => {
  function reveal() {
    var fades = document.querySelectorAll(".animate_img");
    //var titles = document.querySelectorAll(".title-wrap");
    var reveals = document.querySelectorAll(".animate_text");
    for (var i = 0; i < fades.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = fades[i].getBoundingClientRect().top;
      var elementVisible = 50;
      if (elementTop < windowHeight - elementVisible) {
        fades[i].classList.add("visible");
      } else {
        fades[i].classList.remove("visible");
      }
    }

    for (var k = 0; k < reveals.length; k++) {
      var wH = window.innerHeight;
      var eT = reveals[k].getBoundingClientRect().top;
      var eV = 150;
      if (eT < wH - eV) {
        reveals[k].classList.add("visible");
      } else {
        reveals[k].classList.remove("visible");
      }
    }
  }
  window.addEventListener("scroll", reveal);

  reveal();
  const { t, i18n } = useTranslation();
  const sanitizer = dompurify.sanitize;
  const language = useRef(null);

  useEffect(() => {
    language.current = sessionStorage.getItem("language");
    if (language === null) {
      language.current = cookies.get("language");
    }
    i18next.changeLanguage(language.current);
  }, []);
  return (
    <div className="wrapper">
      <SubHeader />
      <div className="section_title">
        <h1 className="headerText">{i18next.t("overview.title")}</h1>
      </div>

      <div className="overview">
        <div className="about_slogan_wrap wrap">
          <h2 className="jt_animate_title" lang="en">
            {i18next.t("overview.title2")}
          </h2>
          <p className="jt_animate_txt">{i18next.t("overview.summary")}</p>
        </div>
        <span className="margin"></span>

        <h1 className="business_header">{i18next.t("overview.areas.title")}</h1>

        <div className="business_wrap">
          <div className="business">
            <div className="business_img animate_img" data-aos="fade-right"></div>
            <div className="business_text animate_text" data-aos="fade-left">
              <div className="business_title">
                <span>{i18next.t("overview.areas.first.title")}</span>
              </div>
              <div className="more">
                <a href="/device">
                  <span className="view_prod">
                    {i18next.t("overview.areas.view_more")}
                  </span>
                </a>
              </div>
              <div className="business_desc">
                <p>{i18next.t("overview.areas.first.summary")}</p>
              </div>
            </div>
          </div>

          <div className="business">
            <div className="business_img animate_img" data-aos="fade-left"></div>
            <div className="business_text animate_text" data-aos="fade-left">
              <div className="business_title">
                <span>{i18next.t("overview.areas.second.title")}</span>
              </div>
              <div className="more">
                <a href="/medicine">
                  <span className="view_prod">
                    {i18next.t("overview.areas.view_more")}
                  </span>
                </a>
              </div>

              <div className="business_desc">
                <p>{i18next.t("overview.areas.second.summary")}</p>
              </div>
            </div>
          </div>

          <div className="business">
            <div className="business_img animate_img" data-aos="fade-right"></div>
            <div className="business_text animate_text" data-aos="fade-left">
              <div className="business_title">
                <span>{i18next.t("overview.areas.third.title")}</span>
              </div>
              <div className="more">
                <a href="/software">
                  <span className="view_prod">
                    {i18next.t("overview.areas.view_more")}
                  </span>
                </a>
              </div>

              <div className="business_desc">
                <p>{i18next.t("overview.areas.third.summary")}</p>
              </div>
            </div>
          </div>
        </div>
       
      </div>
    </div>
  );
};

export default Overview;
